import { styled } from "solid-styled-components";

export const SwitchButton = styled.button<{ active: boolean }>`
  background: ${({ theme }) => theme?.input?.background};
  color: ${({ theme }) => theme?.colors.color};
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: bold;
  ${({ active }) => (active ? "" : "opacity: .5;")}
  &:first-of-type {
    border-radius: 15px 0 0 15px;
  }
  &:last-of-type {
    border-radius: 0 15px 15px 0;
  }
`;
